<template>
  <el-card v-loading="loading || parentLoading" shadow="hover">
    <div style="padding: 10px 20px">
      <div v-if="editModel">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="一级分类" prop="parentGuid" v-if="parentInfo">
            <div>{{ parentInfo.classifyName }} - {{ parentInfo.guid }}</div>
          </el-form-item>
          <el-form-item label="分类名称" prop="classifyName">
            <el-input
              placeholder="请输入分类名称"
              v-model="editModel.classifyName"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="排序编号" prop="optSort">
            <el-input
              type="number"
              v-model="editModel.optSort"
              placeholder="请输入排序编号"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="4"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading && !parentLoading"
        :description="parentErrorMsg || errorMsg"
        :image-size="100"
      >
        <el-button
          v-if="parentErrorMsg || errorMsg"
          @click="fetchModel"
          size="small"
        >
          重新加载
        </el-button>
      </el-empty>
    </div>
  </el-card>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}
</style>

<script>
const defaultModel = {
  optStatus: 1
}

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      parentLoading: false,
      parentErrorMsg: null,
      parentInfo: null,
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        parentGuid: [
          {
            required: true,
            message: "请关联一级分类",
            trigger: "change",
          },
        ],
        classifyName: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = this.editModel.guid
            ? "biz.goods.classify.info.update"
            : "biz.goods.classify.info.create";
          this.requestApi(method, this.editModel, {
            showError: true
          }).then((resp) => {
            this.success("保存成功");
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.parentGuid) {
        this.editModel.parentGuid = this.pageParams.parentGuid;
      }
      this.fetchParentInfo();
    },
    fetchParentInfo() {
      if (this.editModel.parentGuid) {
        this.parentErrorMsg = null;
        this.parentLoading = true;
        this.parentInfo = null;
        this.requestApi("biz.goods.classify.info.detail", {
          guid: this.editModel.parentGuid
        }).then((resp) => {
          this.parentInfo = resp.data;
        }).catch((err) => {
          this.parentErrorMsg = (err && err.msg) || (err && err.message)
            || "连接服务器失败，请检查网络";
        }).finally(() => {
          this.parentLoading = false;
        });
      } else {
        this.parentInfo = null;
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.goods.classify.info.detail", {
          guid: this.pageParams.guid
        }).then((resp) => {
          this.editModel = resp.data;
          this.handleModel();
        }).catch((err) => {
          this.errorMsg = (err && err.msg) || (err && err.message)
            || "连接服务器失败，请检查网络";
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
